module.exports = __webpack_public_path__ + "static/media/eta_blue.fc1a40a7.png";